module.exports = "<main-block></main-block>"